// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
// import 'element-ui/lib/theme-chalk/index.css'
import VueAwesomeSwiper from 'vue-awesome-swiper'

import Homehead from './components/brand-products/head.vue'
import Homebottom from './components/brand-products/bottom.vue'
import VueWechatTitle from 'vue-wechat-title'  //引入



Vue.config.productionTip = false

/* eslint-disable no-new */
Vue.use(ElementUI)
Vue.use(Homehead)
Vue.use(Homebottom)
Vue.use(VueWechatTitle)                                  //注册组件

Vue.component('Home-head', Homehead)
Vue.component('Home-bottom', Homebottom)
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js